import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/plus.svg'


const _withScopeId = n => (_pushScopeId("data-v-7f52ecb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formContainer" }
const _hoisted_2 = {
  key: 0,
  class: "emptyPage"
}
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_5 = { class: "fw_700 mb-0 me-2 mb-0" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "table table-striped w-100" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.waterFootprintList.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_localized_text, {
              localizedKey: "No override found",
              text: "No override found",
              type: "strong"
            }),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-tertiary mt-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewOverrideConfiguration()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Add new configuration",
                    text: "Add new configuration"
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waterFootprintList, (overrideConfig, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(overrideConfig.rawMaterial.text), 1),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-tertiary",
                  onClick: ($event: any) => (_ctx.editOverrideConfiguration(overrideConfig))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Edit",
                    text: "Edit"
                  })
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Production Phase",
                    text: "Production Phase",
                    type: "strong"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Green Water (ml)",
                    text: "Green Water (ml)",
                    type: "strong"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Blue Water (ml)",
                    text: "Blue Water (ml)",
                    type: "strong"
                  })
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Grey Water (ml)",
                    text: "Grey Water (ml)",
                    type: "strong"
                  })
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overrideConfig.waterFootprints, (waterFootprint, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(waterFootprint.productionPhase.text), 1),
                  _createElementVNode("td", null, [
                    (waterFootprint.greenWater)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(waterFootprint.greenWater) + " ml/g", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
                  ]),
                  _createElementVNode("td", null, [
                    (waterFootprint.blueWater)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(waterFootprint.blueWater) + " ml/g", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "--"))
                  ]),
                  _createElementVNode("td", null, [
                    (waterFootprint.greyWater)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(waterFootprint.greyWater) + " ml/g", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "--"))
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      }), 256))
    ]),
    (_ctx.waterFootprintList.length > 0 && !_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-secondary withBorder fixedBottomRight",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewOverrideConfiguration()))
        }, _hoisted_15))
      : _createCommentVNode("", true)
  ], 64))
}